<template>
  <div class="rightAll">
    <div class="rightAll-form">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item :label="$t('common.driverNum')">
          <el-input
            size="mini"
            v-model="formInline.driverNum"
            :placeholder="$t('common.searchTip')"
            style="width: 150px"
            class="input-with-select"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('common.driverName')">
          <el-input
            size="mini"
            v-model="formInline.driverName"
            :placeholder="$t('common.searchTip')"
            style="width: 150px"
            class="input-with-select"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('ContractManagement.contractId')">
          <el-input
            size="mini"
            v-model="formInline.companyName"
            :placeholder="$t('common.searchTip')"
            style="width: 150px"
            class="input-with-select"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('common.setUpTime')">
          <el-date-picker
            v-model="formInline.changeExpireDate"
            type="daterange"
            style="width: 220px"
            size="mini"
            value-format="yyyy-MM-dd"
            range-separator
            :start-placeholder="$t('common.btn.choseDate')"
            end-placeholder
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            size="mini"
            type="primary"
            @click="onSearch"
            class="btn-chaxun"
            >{{$t('common.btn.search')}}</el-button
          >
          <el-button size="mini" @click="onClear" class="btn-del"
            >{{$t('common.btn.cancel')}}</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="rightAll-btn">
      <el-button
      v-if="isPrimaryKey('ANNUALREVIEW_DRIVER_BATCHAPPROVAL')"
        type="text"
        :disabled="selected.length == 0"
        @click="examine"
        >{{$t('GovernmentRegulation.btn.batchApprove')}}</el-button
          >
    </div>
    <i-table
      :list="list"
      :height="height"
      ref="carTable"
      @handleSelectionChange="handleSelectionChange"
      :options="option"
      :columns="columns"
      :operates="operates"
    ></i-table>
    <IPagination ref="page" @PageFun="changeSize"></IPagination>
    <el-dialog
      width="620px"
      :before-close="closeDia"
      class="addDialong"
      :title="$t('GovernmentRegulation.approve')"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form">
        <el-form-item prop="auditState" :label="$t('GovernmentRegulation.form.driverApproveResult')" :label-width="formLabelWidth">
          <el-radio-group v-model="form.auditState">
            <el-radio :label="1">{{$t('GovernmentRegulation.form.pass')}} </el-radio>
            <el-radio :label="2">{{$t('GovernmentRegulation.form.noPass')}} </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
            prop="auditOpinion"
            :label="$t('GovernmentRegulation.auditOpinion')+':'"
            :label-width="formLabelWidth"
          >
            <el-input
              type="textarea"
              :rows="2"
              size="small"
              v-model="form.auditOpinion"
              autocomplete="off"
            ></el-input>
          </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancle('form')"
          >{{$t('common.btn.cancel')}}</el-button
        >
        <el-button
          size="small"
          type="primary"
          @click="submitForm('form')"
          >{{$t('common.btn.confirm')}}</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      width="800px"
      class="tableDialong"
      :before-close="closeImgDia"
      :title="$t('common.picture')"
      :visible.sync="dialogImgFormVisible"
    >
      <img :src="imgUrl" style="width: 100%" />
    </el-dialog>
  </div>
</template>

<script>
import driverAnnualReview from "./driverAnnualReview.js";
export default driverAnnualReview;
</script>

<style lang="less" scoped>
@import "../../../../assets/styles/Style.less";
</style>
